import type { ProductsListColumns } from './types'

export const columnTitleMap: Record<keyof ProductsListColumns, string> = {
  code: 'Код',
  name: 'Наименование',
  trend: 'Напр',
  purchasingGroup: 'ГЗ',
  commodityGroup: 'Тов. группа',
  category: 'Категория',
  subcategory: 'Подкатегория',
  barcodes: 'Штрих-код'
}
